module.exports = __webpack_public_path__ + "img/Dantam Hair 41.e4202ec4.jpg";